import { Draft, PayloadAction } from '@reduxjs/toolkit';

import IGetTraderProfileResponse from 'services/httpClient/responses/auth/IGetTraderProfileResponse';

import { IAuthData } from '../../initialState';

export type ISetProfileAction = IGetTraderProfileResponse;

function setProfile(
  draft: Draft<IAuthData>,
  action: PayloadAction<ISetProfileAction>,
) {
  // Common
  draft.profile.id = action.payload.id;
  draft.profile.email = action.payload.email;
  draft.profile.firstname = action.payload.firstname;
  draft.profile.lastname = action.payload.lastname;
  draft.profile.companyname =
    action.payload.companyname || action.payload.trader_data?.companyname;
  draft.profile.address =
    action.payload.address || action.payload.trader_data?.address;
  draft.profile.city = action.payload.city || action.payload.trader_data?.city;
  draft.profile.locale = action.payload.locale;
  draft.profile.zip = action.payload.zip || action.payload.trader_data?.zip;
  draft.profile.role = action.payload.role;
  draft.profile.intervention_partnership_id =
    action.payload.rik_ip_id || action.payload.intervention_partnership_id;

  // Trader
  draft.profile.mobile_phone = action.payload.mobile_phone;
  draft.profile.phone =
    action.payload.phone || action.payload.trader_data?.phone;
  draft.profile.vat_number =
    action.payload.vat_number || action.payload.trader_data?.vat_number;
  draft.profile.website_url =
    action.payload.website_url || action.payload.trader_data?.website_url;
  draft.profile.matching_locales =
    action.payload.matching_locales ||
    action.payload.trader_data?.matching_locales;
  draft.profile.treetrades =
    action.payload.treetrades || action.payload.trader_data?.treetrades;
  draft.profile.iban = action.payload?.iban;

  // Worker
  draft.profile.intervention_ids = action.payload.intervention_ids;
  draft.profile.trader_id = action.payload.trader_id;
  draft.profile.company_details = action.payload.company_details || false;
  draft.profile.invoice_permission = action.payload.invoice_permission || false;
  draft.profile.user_management = action.payload.user_management || false;
  draft.profile.all_interventions = action.payload.all_interventions || false;
}

export default setProfile;
